import { Component, Inject, OnInit, OnChanges, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";
import { MatSort, MatSortable } from "@angular/material/sort";

@Component({
    selector: "app-security",
    templateUrl: "./security.component.html",
    styleUrls: ["./security.component.scss"],
    standalone: false
})
export class SecurityAccessDialogComponent implements OnInit, OnChanges {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SecurityAccessDialogComponent>,
    private commonService: CommonService,
    public canvasService: CanvasService
  ) {
    if (data) {
      this.securityGroups = data.securityGroups;

      this.canvasType = data.canvasType;
      this.fromCreate = data.fromCreate;
      this.viewMode = data.viewMode;
      if (!this.viewMode) this.displayedColumns = ["name", "edit", "view"];
      else this.displayedColumns = ["name", "view"];
    }
  }
  @ViewChild(MatSort) sort!: MatSort;
  public displayedColumns: string[] = [];
  public dataSource!: any;
  public canvasType!: any;
  public securityGroups: any = [];
  public allSecurityGroups: any = [];
  public fromCreate = false;
  public viewMode = false;
  public userObject = JSON.parse(sessionStorage.getItem("userObject"));
  userGroupId: any;
  editItems: number = 0;

  onNoClick(): void {
    this.dialogRef.close();
  }

  apply(): void {
    this.dialogRef.close(this.dataSource);
  }

  saveAndApply(): void {
    this.canvasService.triggerSave();
    this.dialogRef.close(this.dataSource);
  }

  toggleEdit(row: any) {
    row.edit = !row.edit;
    if (row.edit) row.view = true;
    this.checkEdit(row);
  }
  toggleView(row: any) {
    row.view = !row.view;
    if (!this.viewMode) {
      if (!row.view) row.edit = false;
      if (!row.view) {
        this.checkEdit(row);
      }
    }
  }

  checkEdit(row?: any) {
    this.editItems = 0;
    if (this.securityGroups) {
      this.securityGroups.forEach((element: any) => {
        if (element.edit) {
          this.editItems += 1;
        }
      });
    }
  }
  getAllSecurityGroups() {
    this.commonService.getAllSecurityGroups().subscribe((data: any) => {
      this.allSecurityGroups = data.data;
      this.mergeSecurityGroups();
    });
  }

  mergeSecurityGroups() {
    const A = this.securityGroups;
    const B = this.allSecurityGroups;
    const result = A.concat(
      B.filter((bo: any) => A.every((ao: any) => ao.id != bo.id))
    );
    this.securityGroups = result;

    const isAdmin = this.userObject.isAdmin;
    this.securityGroups.forEach((element: any) => {
      element.edit = element.edit ? true : false;
      element.view = element.view ? true : false;

      if (element.edit) {
        this.editItems += 1;
      }

      if (!isAdmin == true) {
        element.hide = false;
      } else {
        if (element.name == "Administrators" && this.viewMode) {
          element.hide = true;
        } else {
          element.hide = false;
        }
      }
    });

    //remove Administrators from list if logged in user is NOT a admin
    this.dataSource = new MatTableDataSource(<any>this.securityGroups);
    this.dataSource.sort = this.sort;
    this.sort.sort({ id: "name", start: "asc" } as MatSortable);
    this.dataSource.sort = this.sort;
  }

  initForm() {}
  ngOnChanges() {}
  ngOnInit(): void {
    if (this.userObject && this.userObject.userGroupId)
      this.userGroupId = this.userObject.userGroupId;
    else this.userGroupId = 0;
    if (!this.fromCreate) this.getAllSecurityGroups();
    if (this.fromCreate) {
      this.securityGroups.sort((a: any, b: any) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );
      this.dataSource = new MatTableDataSource(<any>this.securityGroups);
      setTimeout(() => {
        this.dataSource.sort = this.sort;
      }, 0);
    }
    this.checkEdit();
  }
}
